import _ from 'lodash';
import { Flex, Heading, Text, Button, Dialog, DialogContentContainer } from '@vibe/core';
import { openPreviewWindow } from '../services/preview';

type OnboardingDialogProps = {
  dialogPosition: any;
  offsetX: number;
  offsetY: number;
  showOnboardingDialogTips: boolean;
  setShowOnboardingDialogTips: (show: boolean) => void;
  onboardingDialogStep: number;
  setOnboardingDialogStep: (step: number) => void;
  dialogStep: number;
  onboardingStepsDialogTotal: number;
  title?: string;
  description: string;
  children: any;
  onStepChange?: (nextStep: number, currentStep: number) => void;
  onDismiss?: () => void;
  onFinalStepDone?: () => void;
  clientBoardItems?: any;
  clientBoard?: any;
};

export function OnboardingDialog({
  dialogPosition,
  offsetX,
  offsetY,
  showOnboardingDialogTips,
  setShowOnboardingDialogTips,
  onboardingDialogStep,
  setOnboardingDialogStep,
  dialogStep,
  onboardingStepsDialogTotal,
  title,
  description,
  children,
  onStepChange,
  onDismiss,
  onFinalStepDone,
  clientBoardItems,
  clientBoard,
}: OnboardingDialogProps) {
  function goToStep(nextStep: number) {
    onStepChange?.(nextStep, onboardingDialogStep);
    setOnboardingDialogStep(nextStep);
  }

  return (
    <Dialog
      id="onboarding-dialog"
      zIndex={5000}
      open={showOnboardingDialogTips && onboardingDialogStep === dialogStep}
      instantShowAndHide
      disableContainerScroll
      //hideWhenReferenceHidden
      preventAnimationOnMount
      tooltip
      position={dialogPosition || 'bottom'}
      moveBy={{ main: offsetX, secondary: offsetY }}
      showTrigger={[]}
      hideTrigger={[]}
      content={
        <DialogContentContainer size="large">
          <div
            style={{
              width: '300px',
            }}
          >
            {title && (
              <Flex gap={8}>
                <Heading
                  type="h3"
                  style={{
                    margin: 0,
                    padding: 0,
                    fontWeight: 600,
                  }}
                >
                  {title}
                </Heading>
              </Flex>
            )}
            <Text type="text2" color="secondary" ellipsis={false} style={{ margin: title ? '6px 0 14px 0' : '0 0 14px 0' }}>
              {description}
            </Text>
            <Flex>
              <Text type="text2" color="primary" ellipsis={false} style={{ fontWeight: 600 }}>
                Tip {dialogStep} of {onboardingStepsDialogTotal}
              </Text>
              <Flex gap={8} justify="end" style={{ marginLeft: 'auto' }}>
                {dialogStep < onboardingStepsDialogTotal ? (
                  <Button
                    size="xs"
                    kind="tertiary"
                    onClick={() => {
                      onDismiss?.();
                      setShowOnboardingDialogTips(false);
                    }}
                  >
                    Dismiss
                  </Button>
                ) : null}
                {/* 
                {dialogStep > 1 && dialogStep < onboardingStepsDialogTotal ? (
                  <Button
                    size="xs"
                    kind="secondary"
                    onClick={() => {
                      goToStep(onboardingDialogStep - 1);
                    }}
                  >
                    Back
                  </Button>
                ) : null}
                */}
                {dialogStep === onboardingStepsDialogTotal ? (
                  <Button
                    size="xs"
                    kind="tertiary"
                    onClick={() => {
                      onDismiss?.();
                      setShowOnboardingDialogTips(false);
                    }}
                  >
                    Not now
                  </Button>
                ) : null}
                <Button
                  size="xs"
                  kind="primary"
                  onClick={() => {
                    if (dialogStep < onboardingStepsDialogTotal) {
                      goToStep(onboardingDialogStep + 1);
                    } else {
                      onFinalStepDone?.();
                      onDismiss?.();
                      setShowOnboardingDialogTips(false);
                    }
                  }}
                >
                  {dialogStep < onboardingStepsDialogTotal ? 'Next' : 'Preview portal'}
                </Button>
              </Flex>
            </Flex>
          </div>
        </DialogContentContainer>
      }
    >
      {children}
    </Dialog>
  );
}
